import script from "./NewsDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewsDetail.vue?vue&type=script&lang=ts&setup=true"

import "./NewsDetail.vue?vue&type=style&index=0&id=7faa9662&scoped=true&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7faa9662"]])

export default __exports__